import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum TradingAccountsFormErrorStatesEnum {
    CreateCashAccountFailed = ErrorStateScheduleEnum.TradingAccountsFormStatesStartIndex,
    CreateTradingAccountFailed,
    UpdateCashAccountFailed,
    UpdateTradingAccountFailed,
    BadAccountReferenceId
}
